import {Dropzone} from 'dropzone';
import 'dropzone/dist/dropzone.css';
import ReCAPTCHAv3 from './common/ReCAPTCHAv3';
import loadScript from './common/loadScript';

const queryString = require('query-string');

require('./modals/success-feedback');

$(function () {
    let $feedbackForm = $('#feedbackForm');
    let $dropzone = $('div#dropzone');
    let $secondStep = $('#stepToggle');

    let App = window.App;
    App.feedback = {};

    let photos = [];

    const initDropzone = function () {
        $dropzone.dropzone({
            url: '/ajax/review-photo-upload',
            addRemoveLinks: true,
            maxFiles: 10,
            acceptedFiles: $dropzone.data('acceptedFiles'),
            dictRemoveFile: $dropzone.data('dictRemoveFile'),
            dictCancelUpload: $dropzone.data('dictCancelUpload'),
            dictDefaultMessage: $('#dropzoneDefaultMessageTemplate').html(),
            init: function() {
                this.on('success', function(data) {
                    photos.push(JSON.parse(data.xhr.response).photo_name);
                });
            },
            removedfile: function (file) {
                let photoName = JSON.parse(file.xhr.response).photo_name;

                if (photos.includes(photoName)) {
                    delete photos[photos.indexOf(photoName)];
                }

                $.ajax({
                    type: 'POST',
                    url: '/ajax/review-photo-delete',
                    data: {
                        name: photoName,
                    },
                    dataType: 'json',
                });

                let ref;
                return (ref = file.previewElement) != null ? ref.parentNode.removeChild(file.previewElement) : void 0;
            }
        });
    }

    const submitForm = function (token = null) {
        if ($feedbackForm.valid()) {
            let data = queryString.parse($feedbackForm.serialize());
            let $btn = $feedbackForm.find('button[type="submit"]:visible');

            if (photos.length) {
                data.photo = photos;
            }

            if (token) {
                data.captcha_token = token;
            }

            $.ajax({
                type: $feedbackForm.attr('method'),
                url: $feedbackForm.attr('action'),
                data: queryString.stringify(data, {arrayFormat: 'bracket'}),
                dataType: 'json',
                beforeSend: function () {
                    $btn.prop('disabled', true);
                    $btn.addClass('is-loading');
                },
                success: function (response) {
                    if (response.status === 'ERROR') {
                        console.error(response.errors);
                        return false;
                    }

                    $feedbackForm.find('input[name="review_id"]').val(response.review_id);

                    if (!$dropzone.hasClass('dz-clickable')) {
                        initDropzone();
                    }

                    if (!$secondStep.is(':checked')) {
                        $secondStep.prop('checked', true);
                    } else {
                        App.modal.open($('#successFeedbackModal'));
                    }
                },
                complete: function () {
                    $btn.prop('disabled', false);
                    $btn.removeClass('is-loading');
                }
            });
        }
    }

    $feedbackForm.submit(function (e) {
        e.preventDefault();

        ReCAPTCHAv3.request('submit', submitForm, console.error);
    });

    App.feedback.onSetRatingClick = function ($this) {
        let $stars = $this.parent().find('svg');

        $stars.each(function (index) {
            if (index < $this.index()) {
                $(this).removeClass('active').addClass('not-active');
            } else {
                $(this).addClass('active').removeClass('not-active');
            }
        });

        let $paramContainer = $this.closest('.param');
        let $input = $paramContainer.find('input[type="hidden"]');
        let value = $stars.length - $this.index();

        if ($paramContainer.hasClass('one')) {
            $input.val(value);
        } else {
            $input.val(`[${$input.data('param-id')}, ${value}]`);
        }
    }

    loadScript('https://www.google.com/recaptcha/api.js?render=' + $feedbackForm.find('input[name="captcha_token"]').val());
});